import React, { Fragment } from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'

import {
    SimpleBlock,
    SimpleCarousel,
} from '../'
import { useWindowSize } from '../../_helpers'
import {
    Container,
    Grid,
    UpperHeader,
    devices,
    colors,
} from '../Common'
import { Instagram } from './Blocks/Instagram'


export const PageBlock = ({ pageBlock, siblings, border, page_menu }) => {
    const { format, subblocks } = pageBlock
    const { width } = useWindowSize()

    return (
        <DynamicWidthBlock
            paddingtop={border ? 50 : 0}
            paddingbottom={['LIST-WITHOUT-PADDING', 'NEWS'].includes(pageBlock.format) ? 0 : 50}
            border={border}
            page_menu={page_menu}
            isFeaturedPlant={format === 'FEATURED-PLANT'}
            id={pageBlock.hash}
        >
            <BlockContainer>
                {pageBlock.hash_url ? <div id={pageBlock.hash_url.toLowerCase().replace(/ /g, '_')} /> : ''}
                {format === 'CAROUSEL' ? <SimpleCarousel slides={pageBlock.carousel} content={pageBlock.content} smallTitle={pageBlock.small_title} /> : ''}
                {format === '1-COLUMN' ? (
                    <SimpleBlock
                        pageBlock={pageBlock}
                        siblings={siblings}
                        columns={1}
                    />
                ) : ''}
                {format === 'INSTAGRAM' ? <Instagram slides={subblocks} /> : ''}
            </BlockContainer>
        </DynamicWidthBlock>
    )
}

const DynamicWidthBlock = styled.div`
    ${({ paddingtop }) => paddingtop && `
        padding-top: ${paddingtop}px;
    `}

    ${({ paddingbottom }) => paddingbottom && `
        padding-bottom: ${paddingbottom}px;
    `}

    ${({ border }) => border && `
        &:before {
            content: "";
            display: block;
            position: relative;
            top: -50px;
            border-top: 1px solid ${colors.darkGreen};
        }
    `}

    ${({ border, page_menu }) => border && !page_menu && `
        &:before {
            width: calc(100% - 105px - 105px);
            max-width: 1100px;
            margin-left: auto;
            margin-right: auto;

            @media ${devices.small} {
                width: calc(100% - 20px - 20px);
            }
        }
    `}
`

const BlockContainer = styled(Container)`
    
`

// const MobileImageBlock = styled.div`
//     background: url(${({ bg }) => bg}) center/cover no-repeat;
//     height: 100vh;
// `

// const MobileText = styled.div`
//     padding: 30px 20px;
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     justify-content: flex-end;
//     color: ${colors.white};
//     height: 100%;
//     background-image: linear-gradient(to bottom, rgba(255,0,0,0), rgba(50,86,68,1));

//     h2 {
//         margin-bottom: 20px;
//     }
// `
